import React, { useEffect, useState } from 'react';
import { Box, Modal, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { addToArray, apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const Conditions = () => {
  const dispatch = useDispatch();
  const { conditions, loadingConditions, loadingDuplication } = useSelector((state) => state.general);
  const [open, setOpen] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(null);

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 250,
      renderCell: (params) => <Link to={`/condition/${params.row._id}`}>{params.value}</Link>,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 200,
    },
    {
      field: 'actions',
      headerName: '',
      width: 500,
      renderCell: (params) => (
        <>
          <Link className='btn btn-sm btn-outline-primary' to={`/condition/${params.row._id}`}>
            View
          </Link>
          <Link className='btn btn-sm btn-outline-secondary ml-2' to={`/editConditionColumns/${params.row._id}`}>
            Edit Columns and Tables
          </Link>
          <Link className='btn btn-sm btn-outline-secondary ml-2' to={`/editrangequery/${params.row._id}`}>
            Edit Range Query
          </Link>
          <button
            className='btn btn-sm btn-outline-dark ml-2'
            disabled={loadingDuplication === params.row._id}
            onClick={() => {
              dispatch(generalSet({ reduxField: 'loadingDuplication', value: params.row._id }));
              dispatch(
                apiAction({
                  reduxField: 'conditions',
                  route: 'conditions/duplicateConditionById',
                  conditionId: params.row._id,
                  addToArray: true,
                  setLoading: 'loadingDuplication',
                })
              );
            }}
          >
            <i className='fa-solid fa-clone'></i>
          </button>
          <button className='btn btn-sm btn-outline-danger ml-2' onClick={() => handleOpen(params.row)}>
            <i className='fa fa-trash' aria-hidden='true'></i>
          </button>
        </>
      ),
    },
  ];

  const handleOpen = (condition) => {
    setSelectedCondition(condition);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCondition(null);
  };

  const handleDelete = () => {
    dispatch(
      apiAction({
        reduxField: 'deletedCondition',
        route: 'conditions/archiveCondition',
        conditionId: selectedCondition._id,
      })
    );
    dispatch(
      generalSet({
        reduxField: 'conditions',
        value: conditions.filter((c) => c._id !== selectedCondition._id),
      })
    );
    handleClose();
  };

  useEffect(() => {
    dispatch(apiAction({ reduxField: 'conditions', route: 'conditions/getConditions' }));
  }, [dispatch]);

  return Array.isArray(conditions) ? (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Conditions</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <Link to='/newCondition' className='btn btn-outline-dark'>
          Create a Condition
        </Link>
      </div>
      {loadingConditions ? (
        <Spinner />
      ) : (
        <>
          <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
            <Box style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={conditions.map((con) => {
                  return { id: con._id, ...con };
                })}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                //   checkboxSelection
                disableSelectionOnClick
              />
            </Box>
          </div>
        </>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className='modal-content'
          style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', outline: 'none', margin: '25%' }}
        >
          <h4>Confirm Deletion</h4>
          <p>Are you sure you want to delete this condition?</p>
          <Button variant='contained' color='secondary' onClick={handleDelete}>
            Delete
          </Button>
          <Button variant='contained' onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  ) : (
    <Spinner />
  );
};

export default Conditions;
